import { render, staticRenderFns } from "./RoleManagementV2.vue?vue&type=template&id=49952188&scoped=true&"
import script from "./RoleManagementV2.vue?vue&type=script&lang=ts&"
export * from "./RoleManagementV2.vue?vue&type=script&lang=ts&"
import style0 from "./RoleManagementV2.vue?vue&type=style&index=0&id=49952188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49952188",
  null
  
)

export default component.exports